import { buildLoader } from '../util/GenericLoader';
import { getUnitsAction } from '../../redux/actions/units';

export default buildLoader(getUnitsAction);
